import axios from 'axios';
import authHeader from './authHeader';
import { API_BASE_URL } from './config';

const API_URL = `${API_BASE_URL}customers/categories/`;

const clientCategoryService = {
  // Get all client categories
  getAllCategories: async () => {
    try {
      const response = await axios.get(API_URL, { headers: authHeader() });
      return response.data;
    } catch (error) {
      console.error('Error fetching client categories:', error);
      throw error;
    }
  },

  // Get a specific category by ID
  getCategoryById: async (id) => {
    try {
      const response = await axios.get(`${API_URL}${id}/`, { headers: authHeader() });
      return response.data;
    } catch (error) {
      console.error('Error fetching client category:', error);
      throw error;
    }
  },

  // Create a new client category
  createCategory: async (categoryData) => {
    try {
      const response = await axios.post(API_URL, categoryData, { headers: authHeader() });
      return response.data;
    } catch (error) {
      console.error('Error creating client category:', error);
      throw error;
    }
  },

  // Update an existing client category
  updateCategory: async (id, categoryData) => {
    try {
      const response = await axios.put(`${API_URL}${id}/`, categoryData, { headers: authHeader() });
      return response.data;
    } catch (error) {
      console.error('Error updating client category:', error);
      throw error;
    }
  },

  // Partially update a client category
  patchCategory: async (id, categoryData) => {
    try {
      const response = await axios.patch(`${API_URL}${id}/`, categoryData, { headers: authHeader() });
      return response.data;
    } catch (error) {
      console.error('Error patching client category:', error);
      throw error;
    }
  },

  // Delete a client category
  deleteCategory: async (id) => {
    try {
      const response = await axios.delete(`${API_URL}${id}/`, { headers: authHeader() });
      return response.data;
    } catch (error) {
      console.error('Error deleting client category:', error);
      throw error;
    }
  },
};

export default clientCategoryService;
